import { RouterView } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';
export const routes: RouteRecordRaw[] = [
  {
    path: 'replenishment',
    component: RouterView,
    children: [
      {
        path: '',
        redirect: '/replenishment/store/overview',
      },
      {
        path: 'warehouse',
        redirect: '/replenishment/store/overview',
      },
      {
        path: 'store',
        component: () => import('@/app/modules/replenishment/views/replenishment-index.vue'),
        props: { locationType: 'store' },
        redirect: '/replenishment/store/overview',
        children: [
          {
            path: 'overview',
            component: () => import('@/app/modules/replenishment/views/replenishment-overview.vue'),
            props: { locationType: 'store' },
            meta: {
              layoutFeatures: {
                actionPanel: true,
              },
            },
          },
          {
            path: 'locations',
            component: () =>
              import('@/app/modules/replenishment/views/replenishment-locations.vue'),
            props: { locationType: 'store' },
            meta: {
              layoutFeatures: {
                actionPanel: true,
              },
            },
          },
          {
            path: 'products',
            component: () => import('@/app/modules/replenishment/views/replenishment-products.vue'),
            props: { locationType: 'store' },
            meta: {
              layoutFeatures: {
                actionPanel: true,
              },
            },
          },
          {
            path: 'inventories',
            component: () =>
              import('@/app/modules/replenishment/views/replenishment-inventories.vue'),
            props: { locationType: 'store' },
            meta: {
              layoutFeatures: {
                actionPanel: true,
              },
            },
          },
        ],
      },
    ],
  },
];
export default routes;
